import { useEffect, useMemo, useRef, useState } from "react";
import { Search, Check, ChevronDown, X } from "lucide-react";

export default function EmpPicker({ options, value, onChange, tid = "rc-emp", placeholder = "Semua Karyawan" }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);
  const filtered = useMemo(() => options.filter((o) => o.name.toLowerCase().includes(q.toLowerCase())), [options, q]);
  const selected = options.filter((o) => value.includes(o.id));
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  return (
    <div ref={ref} className="relative min-w-[240px]">
      <button type="button" data-testid={tid} onClick={() => setOpen((o) => !o)}
        className="w-full min-h-8 px-2.5 py-1 rounded-lg bg-white border border-slate-200 text-[11px] text-slate-700 focus:outline-none focus:border-[#C4738A] flex items-center gap-1.5 flex-wrap text-left">
        {selected.length === 0 && <span className="text-slate-400">{placeholder}</span>}
        {selected.map((o) => (
          <span key={o.id} data-testid={`${tid}-chip-${o.id}`} className="inline-flex items-center gap-1 bg-rose-50 text-[#C4738A] font-semibold rounded-full px-2 py-0.5">
            {o.name}
            <span role="button" tabIndex={0} data-testid={`${tid}-chip-x-${o.id}`} onClick={(e) => { e.stopPropagation(); toggle(o.id); }}
              className="hover:text-[#7C2D3E] cursor-pointer"><X className="w-3 h-3" /></span>
          </span>
        ))}
        <ChevronDown className={`w-3.5 h-3.5 text-slate-300 ml-auto flex-shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div data-testid={`${tid}-dropdown`} className="absolute z-30 mt-1 w-full min-w-[240px] bg-white border border-slate-200 rounded-xl shadow-lg overflow-hidden">
          <div className="p-2 border-b border-slate-100 relative">
            <Search className="w-3.5 h-3.5 text-slate-300 absolute left-[18px] top-1/2 -translate-y-1/2" />
            <input data-testid={`${tid}-search`} autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Ketik nama karyawan..."
              className="h-8 w-full pl-8 pr-2 rounded-lg bg-slate-50 border border-slate-100 text-[11px] focus:outline-none focus:border-[#C4738A]" />
          </div>
          <div className="max-h-52 overflow-y-auto">
            {value.length > 0 && (
              <button data-testid={`${tid}-clear`} onClick={() => onChange([])}
                className="w-full text-left px-3 py-2 text-[10px] font-semibold text-[#C4738A] hover:bg-rose-50/50 border-b border-slate-50">
                Hapus semua pilihan (Semua Karyawan)
              </button>
            )}
            {filtered.map((o) => {
              const on = value.includes(o.id);
              return (
                <button key={o.id} data-testid={`${tid}-opt-${o.id}`} onClick={() => toggle(o.id)}
                  className={`w-full flex items-center gap-2 px-3 py-2 text-left text-[11px] hover:bg-rose-50/40 transition-colors ${on ? "text-[#C4738A] font-semibold" : "text-slate-600"}`}>
                  <span className={`w-3.5 h-3.5 rounded border flex items-center justify-center flex-shrink-0 ${on ? "bg-[#C4738A] border-[#C4738A]" : "border-slate-300 bg-white"}`}>
                    {on && <Check className="w-2.5 h-2.5 text-white" />}
                  </span>
                  {o.name}
                </button>
              );
            })}
            {!filtered.length && <p className="px-3 py-4 text-center text-[10px] text-slate-400">Tidak ada karyawan cocok.</p>}
          </div>
        </div>
      )}
    </div>
  );
}
